module.exports = {
      id: "news-usage",
      viewBox: "0 0 24.597 24.597",
      url: "/" + "sprite-8d2e5ebc566e02833b7f09cd596911c9.svg#news",
      toString: function () {
        return this.url;
      }
    }